import { inject, Injectable } from '@angular/core';
import { TableService } from './table-service';
import { UserService } from '../user.service'; // Make sure the path is correct
import { LoginStateService } from '../../pages/login/login-state.service'; // Make sure the path is correct
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
// import { WorkOrderComponent } from '../../pages/work-order/work-order.component';
@Injectable({
  providedIn: 'root'
})
export class WorkOrderService extends TableService {
    // Add an explicit constructor here
     private datePipe = inject(DatePipe);
  constructor(
     http: HttpClient,
     userService: UserService,
     router: Router,
     datepipe: DatePipe,
     loginStateService: LoginStateService
  ) {
    // Call the base class's constructor with all its required dependencies
    super(http, userService, router, datepipe, loginStateService);
}

  override baseUrl = '/workorders';

  override multilpleFilterBaseUrl = "/multipleworkorders";

  override downloadPOSUrl = "/getpos"

  override downloadInvoiceUrl = "/getinvoice"

}
